import { useEffect, useCallback, useState } from 'react';
import { Player } from 'theoplayer';

import '/node_modules/theoplayer/ui.css';

const THEO_LICENSE =
    'sZP7IYe6T6Pe0Dfz0QCrImzLCD0_FSatIla-TuAg0mkl0Q3eIuCi3uazIDa6FOPlUY3zWokgbgjNIOf9flbr0LRi0oBLFSxKISf-3QxeTmz_0Q4eFDBZIuho3o0zCDIeI6fVfK4_bQgZCYxNWoryIQXzImf90SRc3lez0SCi0u5i0Oi6Io4pIYP1UQgqWgjeCYxgflEc3Lfo0Sa_3SR_TuaoFOPeWok1dDrLYtA1Ioh6TgV6CoX-bQXGWKhpIY3iW6rpWOfVfK4LbQ_pWKi6FOPVWo31WQ1qbta6FOPzdQ4qbQc1sD4ZFK3qWmPUFOPeWok1dDrLYt3qUYPlImf9DZfJf6i6WQjlCDcEWt3zf6i6UQ1gWtAVCYggb6rlWoz6Ymi6box7bZf9DZPEUQkV3mPUFOPLIDreYog-bwPgbt3NWo_6TGxZUDhVfKIgCYxkbK4LflNWYYz';

export function THEOplayerView({ onPlayer, className }) {
    const [player, setPlayer] = useState(null);
    const onMount = useCallback(
        node => {
            if (node) {
                const config = {
                    license: THEO_LICENSE
                };

                setPlayer(new Player(node, config));
            }
        },
        [THEO_LICENSE]
    );

    useEffect(() => {
        if (player && onPlayer) {
            onPlayer(player);
            player.play();
        }
    }, [player, onPlayer]);

    return (
        <div className={className}>
            <div
                className="theoplayer-container video-js theoplayer-skin vjs-16-9 THEOplayer"
                ref={onMount}
            />
        </div>
    );
}
